<script setup lang="ts">
import { useIsMobile } from '@/composables/useMediaQuery'
import type { FilterOption } from '@/types/filter.types'
import { useRouter } from 'vue-router'

const isMobile = useIsMobile()

const props = defineProps<{
  item: FilterOption
}>()

const emit = defineEmits<{
  (e: 'select', program: FilterOption): void
}>()

const router = useRouter()

const navigateTo = () => {
  emit('select', props.item)
  if (props.item.route) {
    router.push(props.item.route)
  }
}
</script>

<template>
  <div class="program-list-item" @click="navigateTo">
    <div class="program-list-item-title title-sm white" :class="{ 'body-md': isMobile }">
      {{ props.item.name }}
    </div>
  </div>
</template>

<style scoped>
.program-list-item {
  width: 250px;
  height: 84px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: var(--gray-800);
  border-radius: 8px;
  padding: 15px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-align: center;
}

@media (max-width: 1365px) {
  .program-list-item {
    width: 144px;
    height: 56px;
    padding: 4px;
  }
}
</style>
